import Slot from "../../../../entities/Slot";
import put from "../../../put";

export const save = (add: Slot[], delete_: Slot[]) =>
    put(`slots`, {add: add.map(s => s.getValue()), delete: delete_.map(s => s.getValue())});